import React from 'react';
export function roleBackground(role:{color?:string;colorSecondary?:string|null}){return role.colorSecondary?`linear-gradient(110deg, ${role.color||'#99aab5'}, ${role.colorSecondary})`:role.color||'#99aab5'}
export function RoleName({role,children}:{role:{color?:string;colorSecondary?:string|null};children:React.ReactNode}){
 return <span className={role.colorSecondary?'role-gradient-text':undefined} style={role.colorSecondary?{backgroundImage:roleBackground(role)}:{color:role.color}}>{children}</span>;
}
